var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-success btn-block",attrs:{"title":this.$root.trans.save},on:{"~click":function($event){return _vm.doStore()}}},[_c('i',{staticClass:"ti-save"})])
}
var staticRenderFns = []

export { render, staticRenderFns }